import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import { useBreakpointsContext } from "@air/provider-media-query";
import { formatFullName, formatInitials } from "@air/utilities";
import { memo, useRef } from "react";
import { COMMENT_AUTHOR_HEADER_LEFT, COMMENT_AVATAR_SIZE } from "~/components/Discussions/Discussion/shared/constants";
import { useCommentReply } from "~/components/Discussions/Discussion/shared/useCommentReply";
import { DiscussionForm } from "~/components/Discussions/DiscussionForm";
import { DISCUSSION_REPLY_COMMENT_AVATAR, REPLY_COMMENT_FORM } from "~/constants/testIDs";
import { getAvatarImageSrc } from "~/utils/getAvatarImageSrc";
export const CommentReply = /*#__PURE__*/ memo((param)=>{
    let { discussionId, onSubmit, mentionsList, shouldShowMentionsButton, user } = param;
    const fullName = user ? formatFullName(user.firstName, user.lastName) : "";
    const initials = user ? formatInitials(user.firstName, user.lastName) : "";
    const discussionFormRef = useRef(null);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const { onCommentSubmit, isAddingReply, clearReplyingDiscussionId } = useCommentReply({
        discussionId,
        onSubmit,
        formRef: discussionFormRef
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex py-5 pr-5",
        style: {
            marginLeft: COMMENT_AUTHOR_HEADER_LEFT
        },
        children: [
            !!user && /*#__PURE__*/ _jsx(Avatar, {
                className: "!mr-2",
                alt: fullName,
                "data-testid": DISCUSSION_REPLY_COMMENT_AVATAR,
                size: COMMENT_AVATAR_SIZE,
                src: getAvatarImageSrc(user.avatar, COMMENT_AVATAR_SIZE),
                text: initials,
                colorSeed: user.id
            }),
            /*#__PURE__*/ _jsx(DiscussionForm, {
                "data-testid": REPLY_COMMENT_FORM,
                ref: discussionFormRef,
                hasCancelButton: isAddingReply && !isAboveMediumScreen,
                onCancel: clearReplyingDiscussionId,
                onSubmit: onCommentSubmit,
                mentionsList: mentionsList,
                placeholder: "Write a reply...",
                shouldShowMentionsButton: shouldShowMentionsButton,
                onOutsideClick: clearReplyingDiscussionId
            })
        ]
    });
});
CommentReply.displayName = "CommentReply";
